module.exports = __webpack_public_path__ + "static/media/Nicolas_Martinez_Garcia.cac9300f.jpg";